export const DELETE_PRESET_REQUEST = 'DELETE_PRESET_REQUEST';
export const deletePreset = (presetId) => ({
  type: DELETE_PRESET_REQUEST,
  presetId,
});

export const DELETE_PRESET_SUCCESS = 'DELETE_PRESET_SUCCESS';
export const deletePresetSuccess = (presetId) => ({
  type: DELETE_PRESET_SUCCESS,
  presetId,
});

export const GET_PRESETS_REQUEST = 'GET_PRESETS_REQUEST';
export const getPresets = () => ({
  type: GET_PRESETS_REQUEST,
});

export const CREATE_OR_UPDATE_PRESET_REQUEST = 'CREATE_OR_UPDATE_PRESET_REQUEST';
export const createOrSavePreset = (presetId, preset) => ({
  type: CREATE_OR_UPDATE_PRESET_REQUEST,
  presetId,
  preset,
});

export const CREATE_OR_UPDATE_PRESET_SUCCESS = 'CREATE_OR_UPDATE_PRESET_SUCCESS';
export const createPresetSuccess = (preset) => ({
  type: CREATE_OR_UPDATE_PRESET_SUCCESS,
  preset,
});

export const CREATE_OR_UPDATE_PRESET_FAILURE = 'CREATE_OR_UPDATE_PRESET_FAILURE';
export const createPresetFailure = (error) => ({
  type: CREATE_OR_UPDATE_PRESET_FAILURE,
  error,
});

export const HOTKEY_APPLY_PRESET_REQUEST = 'HOTKEY_APPLY_PRESET_REQUEST';
export const hotkeyApplyPreset = ({ hotkey, fulfillmentPlanIds, callbackWithPayload }) => ({
  type: HOTKEY_APPLY_PRESET_REQUEST,
  hotkey,
  fulfillmentPlanIds,
  callbackWithPayload,
});

export const UPDATE_PRESET_HOTKEYS_SUCCESS = 'UPDATE_PRESET_HOTKEYS_SUCCESS';
export const updatePresetHotkeysSuccess = (presetHotkeys) => ({
  type: UPDATE_PRESET_HOTKEYS_SUCCESS,
  payload: {
    presetHotkeys,
  },
});

export const PRESET_READ_FROM_SCALE = 'PRESET_READ_FROM_SCALE';
export const readFromScale = (scale, requestId, callBack) => ({
  type: PRESET_READ_FROM_SCALE,
  scale,
  requestId,
  callBack,
});
